module.exports = ":host {\n  color: inherit; }\n"